import React from 'react';
import useTranslation from '../../hooks/useTranslation';
import { useLayoutState } from '../../layout/Context';
import Link from '../Link';
import Typography from '../Typography';

const Credits = () => {
  const { locale } = useLayoutState();
  const { t } = useTranslation('credits', locale);

  return (
    <>
      <Typography variant="small" className="hidden lg:block">
        {t('Supported by the project')}
        <br />
        <Link to="https://folklore.com.ua/">
          {t('Pearls of Ukrainian Folk Art')}
        </Link>
      </Typography>
      <Typography variant="small">
        <Link to="https://pratsko.dev/">
          {t('website development')}
        </Link>
        {' '}
        <Link to="https://pratsko.dev/">
          pratsko.dev
        </Link>
      </Typography>
    </>
  );
};

export default Credits;
